import { LoadingSpinner } from "@drs-ops/ui/feedback";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { TierEquivalencyRow } from "@/components/settings/TierEquivalencyRow";
import { useAdminApi } from "@/hooks/useAdminApi";
import type { HotelTierMapRow } from "@/types/hotelTierMap";

export function TierEquivalenciesTab(): React.ReactElement {
  const api = useAdminApi();
  const qc = useQueryClient();
  const list = useQuery({
    queryKey: ["hotel-tier-map"],
    queryFn: () => api.get<HotelTierMapRow[]>("/api/hotel-tier-map"),
  });
  const mutation = useMutation({
    mutationFn: ({ brand, comparable }: { brand: string; comparable: string[] }) =>
      api.patch<HotelTierMapRow>(`/api/hotel-tier-map/${encodeURIComponent(brand)}`, {
        comparable_brands: comparable,
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["hotel-tier-map"] }),
  });

  if (list.isLoading || !list.data) return <LoadingSpinner className="my-12" />;

  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-muted-foreground">Edit comparable non-Hilton brands per tier. Comma-separated.</p>
      <div className="rounded-md border border-border">
        <table className="w-full text-sm">
          <thead className="border-b border-border bg-muted/50 text-left">
            <tr>
              <th className="p-2">Hilton brand</th>
              <th className="p-2">Tier</th>
              <th className="p-2">Comparable non-Hilton</th>
            </tr>
          </thead>
          <tbody>
            {list.data.map((r) => (
              <TierEquivalencyRow
                key={r.hilton_brand}
                row={r}
                onSave={(brand, comparable) => mutation.mutate({ brand, comparable })}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
